ReferencesControleController.$inject = [
    '$scope',
    '$state',
    '$stateParams',
    '$translate',
    'MassiaApplicationService',
    'ModalService',
    'PaginationService',
    'ReferencesControleService',
    'notification',
    'ReferencesControleTypesService',
    '$transitions',
    'MOPService'
];

// Du fait d'une limitation d'angularJS et de blocks.smart.table
// le controller doit être déclaré comme une fonction et non une classe
// on injecte donc directement les dépendances dans la fonction comme le veut angularJS
export default function ReferencesControleController(
    $scope,
    $state,
    $stateParams,
    $translate,
    MassiaApplicationService,
    ModalService,
    PaginationService,
    ReferencesControleService,
    notification,
    ReferencesControleTypesService,
    $transitions,
    MOPService
) {
    const vm = this;
    const watchers = [];

    let previousTableState;
    vm.selectedReferenceId = undefined;
    vm.lastSelected = undefined;

    vm.loading = false;
    vm.params = $stateParams;
    vm.state = $state;
    vm.MassiaApplicationService = MassiaApplicationService;
    vm.references = [];

    vm.slideWidth = '500px';
    vm.slideMargin = {
        'margin-right': '0px',
        'transition-duration': '0.5s',
        'transition-animation': 'margin-right'
    };

    vm.itemsByPageOptions = [20, 100, 200];
    vm.itemsByPage = vm.itemsByPageOptions[0];

    vm.selectRefControle = selectRefControle;
    vm.isReferenceSelected = isReferenceSelected;
    vm.showDetail = showDetail;
    vm.closeDetail = closeDetail;
    vm.loadReferences = loadReferences;
    vm.deleteReference = deleteReference;
    vm.setSelected = setSelected;
    vm.eraseAllFilters = eraseAllFilters;
    vm.getDomaineCourant = getDomaineCourant;
    vm.duplicateReference = duplicateReference;
    vm.exporter = exporter;
    vm.application = vm.MassiaApplicationService.getApplication();
    vm.MOPService = MOPService;

    function init() {
        vm.MOPService.setMop([{ title: 'REFERENCES.BREADCRUMBS.REFERENCES_LIST', filename: 'References.pdf', application: 'laboratoire' }]);
        //écouter l'event lié au changement de route
        //une fois on change l'url, et on arrive sur la page "references.list", on désélectionne la ligne sélectionnée (s'il y en a)
        $transitions.onSuccess({}, stateChangeSuccessFunc);
        watchers.push($scope.$on('$destroy', dispose));

        //quand on est sur la page ayant la vue détail ouverte, on présélectionne la ligne
        if (shouldSetSelectedId()) {
            vm.setSelected({ id: parseInt($state.params.id) });
        }

        getTypes();
    }

    init();

    vm.$onDestroy = () => {
        vm.MOPService.resetMop();
    };

    function getDomaineCourant() {
        const domaine = $state.current.name;
        return domaine.substring(0, domaine.indexOf('.'));
    }

    function isActuListe() {
        return $state.current.name.indexOf('list') >= 0;
    }

    function stateChangeSuccessFunc(event, toState) {
        if (!$state.params.id) {
            vm.setSelected();
        } else {
            vm.setSelected({ id: parseInt($state.params.id) });
        }
    }

    async function getTypes(event, toState) {
        vm.types = await ReferencesControleTypesService.getAll(getDomaineCourant());
    }

    function setSelected(reference) {
        if (reference && reference.id) {
            vm.selectedReferenceId = $stateParams.id;
            vm.lastSelected = vm.selectedReferenceId;
            vm.slideMargin['margin-right'] = vm.slideWidth;
        } else {
            vm.selectedReferenceId = undefined;
            vm.slideMargin['margin-right'] = '0px';
        }
    }

    function shouldSetSelectedId() {
        return $state && $state.current && $state.current.name && !isActuListe() && $stateParams && $stateParams.id;
    }

    function selectRefControle(reference) {
        if (reference && reference.id) {
            //si c'est une nouvelle ligne qui a été sélectionnée, on update la variable locale selectedReferenceId, et charger la vue détail pour le reference sélectionné
            if (vm.selectedReferenceId !== reference.id) {
                vm.selectedReferenceId = reference.id;
                showDetail(reference.id);
            } else {
                //si on click sur la ligne qui est déjà sélectionnée, on ferme la vue détail
                vm.selectedReferenceId = undefined;
                closeDetail();
            }
        }
    }

    function isReferenceSelected(reference) {
        return reference && reference.id && vm.selectedReferenceId === reference.id;
    }

    function showDetail(referenceId) {
        $state.go(getDomaineCourant() + '.list.detail', { id: referenceId });
    }

    function closeDetail() {
        $state.go(getDomaineCourant() + '.list');
    }

    async function loadReferences(tableState) {
        startLoading();

        //quand on rafraîchit la grille, on revient sur "references.list", et on ferme la vue détail d'un docce
        //sinon, on risque d'avoir la vue détail qui est ouverte, mais la ligne n'apparaît plus dans la grille
        if ($state && $state.current && !isActuListe() /*$state.current.name !== 'references.list'*/) {
            $state.go(getDomaineCourant() + '.list');
        }

        if (tableState) {
            previousTableState = tableState;
        }

        const filters = PaginationService.getFilters(previousTableState);
        const sorts = PaginationService.getSorts(previousTableState);
        const pagination = PaginationService.getPagination(previousTableState);

        vm.references = [];

        try {
            const data = await ReferencesControleService.getReferences(filters, sorts, pagination, getDomaineCourant());

            vm.references = data.items;

            if (previousTableState) {
                PaginationService.setTableState(data.skip, data.take, data.total, previousTableState);
            }
        } catch (ex) {
            notification.error(ex.data);
        } finally {
            stopLoading();
        }
    }

    async function deleteReference(reference) {
        if (reference && reference.id) {
            const modalInstance = ModalService.confirm({
                modalTitle: $translate.instant('REFERENCES.DELETE.TITLE', { libelle: reference.libelle }),
                modalMsg: $translate.instant('REFERENCES.DELETE.MESSAGE'),
                headerClass: 'modal-danger'
            });

            modalInstance.result.then(async function () {
                startLoading();
                try {
                    await ReferencesControleService.deleteReferenceById(reference.id);
                    notification.success($translate.instant('REFERENCES.DELETE.SUCCESS'));

                    vm.selectedReferenceId = undefined;

                    // si jamais la vue détail est affichée,
                    // on va faire une rédirection vers la vue de la grille, adin de fermer la vue détail
                    if (vm.params.id) {
                        vm.state.go(getDomaineCourant() + '.list');
                    }
                    previousTableState = PaginationService.getTableStateAfterDelete(previousTableState, previousTableState.pagination.take);
                    loadReferences();
                } catch (ex) {
                    notification.error(ex.data);
                } finally {
                    stopLoading();
                }
            });
        }
    }

    function duplicateReference(reference) {
        if (reference && reference.id) {
            $state.go(getDomaineCourant() + '.duplicate', { id: reference.id });
        }
    }

    function eraseAllFilters() {
        loadReferences();
    }

    async function exporter(modeImpression) {
        try {
            const filters = PaginationService.getFilters(previousTableState);
            const sorts = PaginationService.getSorts(previousTableState);
            const fileName = 'Liste_references';
            let resultat = undefined;
            try {
                resultat = await ReferencesControleService.exportListeReferences(getDomaineCourant(), modeImpression, filters, sorts);
            } catch (ex) {
                //si on a des exception à afficher, le faire de cette manière à cause du format de retour de type fichier
                const msgException = String.fromCharCode.apply(null, new Uint8Array(ex.data));
                notification.error('REFERENCES.' + msgException);
                return false;
            }
            if (resultat) {
                const data = resultat.data;
                const status = resultat.status;
                let headers = resultat.headers;
                headers = headers();

                const contentType = headers['content-type'];

                const linkElement = document.createElement('a');
                try {
                    const blob = new Blob([data], { type: contentType + ';charset=UTF-8' });
                    const url = window.URL.createObjectURL(blob);
                    linkElement.setAttribute('href', url);
                    if (modeImpression == 0) {
                        linkElement.setAttribute('download', fileName + '.pdf');
                    } else {
                        linkElement.setAttribute('download', fileName + '.xlsx');
                    }

                    const clickEvent = new MouseEvent('click', {
                        view: window,
                        bubbles: true,
                        cancelable: false
                    });
                    linkElement.dispatchEvent(clickEvent);
                } catch (ex) {
                } finally {
                }
                return true;
            }
        } catch (ex) {
            this.notification.error(ex.data);
            return false;
        }
    }

    function startLoading() {
        vm.loading = true;
    }

    function stopLoading() {
        vm.loading = false;
    }

    function dispose() {
        watchers.forEach((x) => x());
    }
}
